/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScheduleWindow } from './scheduleWindow';

/**
 * Read shape for ``GET /api/org/outreach-settings``.
 */
export interface OrgOutreachSettingsResponse {
  org_id: string;
  default_timezone: string;
  default_schedule_windows: ScheduleWindow[];
  default_skip_holidays: boolean;
  updated_at: string;
  updated_by_user_id: string;
}
